import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  collections: {},
  statistics: {},
  requesting: true,
  statisticsLoading: false,

  isDeleted: false,
  deleting: false,

  isToggled: false,
  toggling: false,

  isBulkDeleted: false,
  bulkDeleting: false,

  isExported: false,
  exporting: false,

  errors: {}
};

const Slice = createSlice({
  name: '@admin/Inventory|Types|List',
  initialState,
  reducers: {
    
    getList: (state, action) => {
        state.collections = {};
        state.requesting = true;
    },
    getListSuccess: (state, action) => {
        const { payload } = action;
        state.collections = payload;
        state.requesting = false;
    },
    getListFailed: (state, action) => {
        state.errors = action.payload;
        state.requesting = false;
    },

  // ----- STATISTICS ----- 
    getStatistics: (state) => {
        state.statistics = {};
        state.statisticsLoading = true;
    },
    getStatisticsSuccess: (state, action) => {
        const { payload } = action;
        state.statistics = payload;
        state.statisticsLoading = false;
    },
    getStatisticsFailed: (state, action) => {
        state.errors = action.payload;
        state.statisticsLoading = false;
    },

  // ----- DELETE ----- 
    toDelete: (state) => {
        state.isDeleted = false;
        state.deleting = true;
    },
    toDeleteSuccess: (state) => {
        state.isDeleted = true;
        state.deleting = false;
    },
    toDeleteFailed: (state, action) => {
        state.errors = action.payload;
        state.deleting  = false;
        state.isDeleted = false;
    },

  // ----- TOGGLE STATUS ----- 
    toggleStatus: (state) => {
        state.isToggled = false;
        state.toggling = true;
    },
    toggleStatusSuccess: (state) => {
        state.isToggled = true;
        state.toggling = false;
    },
    toggleStatusFailed: (state, action) => {
        state.errors = action.payload;
        state.toggling = false;
        state.isToggled = false;
    },

  // ----- BULK DELETE ----- 
    bulkDelete: (state) => {
        state.isBulkDeleted = false;
        state.bulkDeleting = true;
    },
    bulkDeleteSuccess: (state) => {
        state.isBulkDeleted = true;
        state.bulkDeleting = false;
    },
    bulkDeleteFailed: (state, action) => {
        state.errors = action.payload;
        state.bulkDeleting = false;
        state.isBulkDeleted = false;
    },

  // ----- EXPORT ----- 
    exportData: (state) => {
        state.isExported = false;
        state.exporting = true;
    },
    exportDataSuccess: (state) => {
        state.isExported = true;
        state.exporting = false;
    },
    exportDataFailed: (state, action) => {
        state.errors = action.payload;
        state.exporting = false;
        state.isExported = false;
    },
    
  },
});

export const Actions = Slice.actions;

const Reducers = {
  AdminInventoryTypesReducers: Slice.reducer,
}
export default Reducers;
